import React, { Component } from 'react';
import DateandTime from './DateandTime';

class CreateTransportFees extends Component {
	constructor(props) {
		super(props);

		this.state = {
			AdminName: '',
			AdminType: '',
			RouteId: '',
			StudentId: '',
			ClassId: '',
			RouteFee: '',
			AmountPaid: '',
			AmountDue: ''
		};
	}

	onHandleTextChange = e => {
		console.log(e.target.value);
		this.setState({
			[e.target.name]: e.target.value
		});
	};
	onHandleSubmit = e => {
		e.preventDefault();
		console.log(this.state);
	};
	render() {
		return (
			<div>
				<section class="mb-4">
					<h2 class="h1-responsive font-weight-bold text-center my-4">
						Create Transport Fees
					</h2>

					<p class="text-center w-responsive mx-auto mb-5" />

					<div
						class="row"
						style={{ justifyContent: 'Center', textAlign: 'Center' }}
					>
						<div
							class="col-md-9 mb-md-0 mb-5"
							style={{
								border: 'solid',
								borderColor: '#01ac8a',
								padding: 40,
								borderRadius: 15,
								width: 'auto'
							}}
						>
							<form id="contact-form" name="contact-form">
								<div class="row">
									<div class="col-md-12">
										<div class="md-form mb-0">
											<DateandTime />
										</div>
									</div>
								</div>
								<br />
								<div class="row">
									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="name" class="">
												<i
													style={{ marginRight: 4 }}
													className="fas fa-user-shield animated fadeIn"
												/>
												Admin Name
											</label>
											<input
												type="text"
												name="AdminName"
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="name" class="">
												<i
													style={{ marginRight: 4 }}
													className="fas fa-user-alt animated fadeIn"
												/>
												Admin Type
											</label>
											<input
												type="text"
												name="AdminType"
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>
									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="email" class="">
												<i
													className="fas fa-id-badge"
													style={{ marginRight: 4 }}
												/>
												Class Name
											</label>
											<select
												onChange={this.onHandleTextChange}
												class="custom-select"
												name="ClassId"
											>
												<option selected>Names</option>
												<option value="1">Name 1</option>
												<option value="2">Name 2</option>
												<option value="3">Name 3</option>
											</select>
										</div>
									</div>
									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="email" class="">
												<i
													className="fas fa-user-graduate"
													style={{ marginRight: 4 }}
												/>
												Student Name
											</label>
											<select
												onChange={this.onHandleTextChange}
												class="custom-select"
												name="StudentId"
											>
												<option selected>Names</option>
												<option value="1">Hamza</option>
												<option value="2">Taha</option>
												<option value="3">Adil</option>
											</select>
										</div>
									</div>

									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="email" class="">
												<i
													className="fas fa-route"
													style={{ marginRight: 4 }}
												/>
												Route Name
											</label>
											<select
												onChange={this.onHandleTextChange}
												class="custom-select"
												name="RouteId"
											>
												<option selected>Name...</option>
												<option value="1">abc</option>
												<option value="2">bcd</option>
												<option value="3">dcs</option>
											</select>
										</div>
									</div>

									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="name" class="">
												<i
													class="fas fa-file-invoice-dollar"
													style={{ marginRight: 4 }}
												/>
												Route Fee
											</label>
											<input
												type="text"
												name="RouteFee"
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="name" class="">
												<i class="fas fa-donate" style={{ marginRight: 4 }} />
												Amount Paid
											</label>
											<input
												type="text"
												name="AmountPaid"
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>

									<div class="col-md-6">
										<div class="md-form mb-0">
											<label for="name" class="">
												<i
													class="fas fa-hand-holding-usd"
													style={{ marginRight: 4 }}
												/>
												Amount Due
											</label>
											<input
												type="text"
												name="AmountDue"
												class="form-control"
												onChange={this.onHandleTextChange}
											/>
										</div>
									</div>
								</div>
							</form>
							<br />
							<br />
							<div class="text-center text-md-center">
								<button onClick={this.onHandleSubmit} class="btns">
									Create
								</button>
							</div>
							<div class="status" />
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default CreateTransportFees;
